module.exports = __webpack_public_path__ + "img/DE02689.a4698cbb.png";